<template>
  <div class="menu-bar" :style="{'width':menuWidth,'height':menuHeight}">
    <div class="menu-box-left" :style="{'right': '10px','height':menuRightHeight,'background-size':'215px '+menuRightHeight}" v-if="isLeft"></div>
    <div class="menu-box-right" :style="{'right': '40px','height':menuRightHeight,'background-size':'215px '+menuRightHeight}" v-else></div>
    <div class="menu-box-content" :style="{'width':menuWidth}">
      <slot name="menu-title"></slot>
      <slot name="menu-list"></slot>
    </div>
  </div>
</template>

<script>
import Techbtn from './tech-btn.vue'

export default {
  props: {
    isLeft: {
      type: Boolean,
      default: false
    },
    menuWidth: {
      type: String,
      default: '230px'
    },
    menuHeight: {
      type: String,
      default: '530px'
    },
    menuRightHeight: {
      type: String,
      default: '570px'
    },
    menuListHeight: {
      type: String,
      default: '500px'
    }
  },
  components: {
    Techbtn
  }
}
</script>

<style lang="scss">
.menu-bar {
  position: absolute;
  // top: 120px;
  // width: var(--menu-width);
  // height: var(--menu-height);
  background-color: rgba(21, 37, 54, 0.2); // #152536;
  border: 1px solid #00edff;
  // position: relative;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 10px 10px 15px;
  pointer-events: auto;
  z-index: 1000;

  transition: display 0.5s;
  -moz-transition: display 0.5s; /* Firefox 4 */
  -webkit-transition: display 0.5s; /* Safari and Chrome */
  -o-transition: display 0.5s; /* Opera */

  // &__right {
  //   // margin-right: var(--x-left);
  //   transition: display 0.5s;
  //   -moz-transition: display 0.5s; /* Firefox 4 */
  //   -webkit-transition: display 0.5s; /* Safari and Chrome */
  //   -o-transition: display 0.5s; /* Opera */
  // }

  .menu-box-left {
    position: absolute;
    left: 40px;
    // top: 90px;
    top: -20px;
    margin: 0;
    padding: 0;
    width: 215px;
    // height: var(--menu-right-height); //540px; //992px;
    z-index: 40;
    will-change: transform;
    pointer-events: none;
    // background-size: 215px var(--menu-right-height);
    background-repeat: no-repeat;
    background-image: url(/static/img/right_pattern@2x.png);
  }
  .menu-box-right {
    position: absolute;
    right: 40px;
    // top: 90px;
    top: -20px;
    margin: 0;
    padding: 0;
    width: 215px;
    // height: var(--menu-right-height); //540px; //992px;
    z-index: 40;
    will-change: transform;
    pointer-events: none;
    // background-size: 215px var(--menu-right-height);
    background-repeat: no-repeat;
    background-image: url(/static/img/left_pattern@2x.png);
  }
  .menu-box-content {
    position: absolute;
    top: 0px;
    left: 0px;
    padding-right: 2px;
    padding-left: 2px;
    // width: var(--menu-width);
    text-align: center;
    z-index: 1000;

      .btn-list {
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 5px;
        margin-left: -1px;
        max-height: 500px;
      }
    .menu-box-list {
      /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
      ::-webkit-scrollbar {
        width: 5px; /*滚动条宽度*/
        height: 15px; /*滚动条高度*/
      }
      scrollbar[orient="vertical"] {
        margin-left: -5px !important;
        max-width: 5px !important;
        min-width: 5px !important;
      }

      /*定义滚动条轨道 内阴影+圆角*/
      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px; /*滚动条的背景区域的圆角*/
        background-color: #afb1b1; /*滚动条的背景颜色*/
      }
      scrollbar-track-color:#afb1b1;/*IE 滚动条背景颜色*/

      /*定义滑块 内阴影+圆角*/
      ::-webkit-scrollbar-thumb {
        border-radius: 10px; /*滚动条的圆角*/
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: rgba(0, 224, 255, 0.45); /*滚动条的背景颜色*/
      }
      scrollbar-face-color:rgba(0, 224, 255, 0.45);/*滚动条颜色*/

      .menu-item {
        margin-top:20px;
        margin-left:50px;
      }

      .el-menu {
        // max-height: var(--menu-list-height);
        overflow-x: hidden;
        overflow-y: auto;
        margin-left: -1px;
        text-align: left;
        border-right: none;
        span {
          margin-left: 3px;
        }
      }

      .el-submenu .el-menu-item {
        background-color: #000c17 !important;
        overflow: hidden;
      }

      .el-submenu__title,
      .el-menu-item {
        // border-bottom: 1px solid #fff;
        i {
          color: #a7aaae;
        }

        &.is-active i {
          color: #fff;
        }
      }

      .el-menu-item.is-active {
        background-color: $primary-color !important;
      }
    }
  }

  .menu-box-title {
    font-size: 18px;
    color: #00edff;
    background-image: linear-gradient(
      -90deg,
      rgba(8, 57, 79, 0) 0%,
      #073a51 50%,
      rgba(8, 54, 79, 0) 100%
    );
    border-bottom: solid 2px black;
    -o-border-image: linear-gradient(
        -90deg,
        rgba(0, 237, 255, 0) 0%,
        rgba(0, 237, 255, 0) 10%,
        rgba(0, 237, 255, 1) 50%,
        rgba(0, 237, 255, 0) 100%
      )
      2% stretch;
    border-image: linear-gradient(
        -90deg,
        rgba(0, 237, 255, 0) 0%,
        rgba(0, 237, 255, 0) 10%,
        rgba(0, 237, 255, 1) 50%,
        rgba(0, 237, 255, 0) 100%
      )
      2% stretch;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tech/menubar.vue